import { Create } from 'react-admin';
import { TicketQueueForm } from './index';

export const TicketQueueCreate = () => (
  <Create>
    <TicketQueueForm />
  </Create>
);
